<h1 mat-dialog-title>
    <span *ngIf="!data?.id">{{
        "taggable-resource-route.dialog.create" | translate
    }}</span>
    <span *ngIf="data?.id">{{
        "taggable-resource-route.dialog.edit" | translate
    }}</span>
</h1>
<app-taggable-resource-route-form
  [loading_icon]="loading"
  [entity]="entity$ | async"
  [error]="(errors$ | async) ?? null"
  [groups]="groups$ | async"
  [ods_id]="ods_id$ | async" 
  [lists]="list$ | async"
  [waste_types]="type$ | async"
  (destroy)="destroy()"
  (saveData)="saveData($event)"
></app-taggable-resource-route-form>
    